import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Site Configuration
export const getSiteConfig = () => api.get('/config');
export const getImages = () => api.get('/images');
export const getExternalLinks = () => api.get('/links');

// Companies
export const getCompanies = (featured) => {
  const params = featured !== undefined ? { featured } : {};
  return api.get('/companies', { params });
};
export const getCompany = (id) => api.get(`/companies/${id}`);

// Articles (legacy)
export const getArticles = (params = {}) => api.get('/articles', { params });
export const getArticle = (slug) => api.get(`/articles/${slug}`);

// Blog Posts (legacy)
export const getBlogPosts = (tag) => {
  const params = tag ? { tag } : {};
  return api.get('/blog', { params });
};
export const getBlogPost = (slug) => api.get(`/blog/${slug}`);

// Publications (IP page media)
export const getPublications = (featured) => {
  const params = featured !== undefined ? { featured } : {};
  return api.get('/publications', { params });
};
export const getPublication = (id) => api.get(`/publications/${id}`);

// Intellectual Property
export const getTrademarks = () => api.get('/ip/trademarks');
export const getPatents = () => api.get('/ip/patents');
export const getDesigns = () => api.get('/ip/designs');

// Charitable Causes
export const getCauses = (featured) => {
  const params = featured !== undefined ? { featured } : {};
  return api.get('/causes', { params });
};
export const getCause = (id) => api.get(`/causes/${id}`);

// About
export const getAbout = () => api.get('/about');

// Meta
export const getCategories = () => api.get('/categories');
export const getTopics = () => api.get('/topics');

// Company Details
export const getLetwiseDetail = () => api.get('/companies/letwise');
export const getRLKDetail = () => api.get('/companies/rlk');

// Papers / Publications System
export const getPapers = (params = {}) => api.get('/papers', { params });
export const getPaper = (id) => api.get(`/papers/${id}`);
export const getPaperTags = () => api.get('/papers/tags');
export const getUploadUrl = (filename) => `${API_BASE_URL}/api/uploads/${filename}`;
export const getDownloadUrl = (filename) => `${API_BASE_URL}/api/downloads/${filename}`;

// Admin
export const adminLogin = (password) => api.post('/admin/login', { password });

export const adminCheckToken = (token) => {
  return api.get('/admin/check', {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const adminCreatePaper = (formData, token) => {
  return axios.post(`${API_BASE_URL}/api/admin/papers`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const adminUpdatePaper = (id, formData, token) => {
  return axios.put(`${API_BASE_URL}/api/admin/papers/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const adminDeletePaper = (id, token) => {
  return api.delete(`/admin/papers/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export default api;
